import React from 'react';
import PropTypes from 'prop-types';
import Item from './Item.jsx';
import Pagination from 'components/Pagination/TablePagination';

function List({
  values,
  paginationProps,
  showUsersModal
}) {
  return (
    <div>
      <div className="container_result_statistic_table row">
        <p className="container_result_webinar col s3">WEBINAR</p>
        <p className="container_result_number col s2">№ OF PARTICIPANTS (live)</p>
        <p className="container_result_number col s2">№ OF VIEWS (recorded)</p>
        <p className="container_result_download col s2">№ OF CERTS DOWNLOADED</p>
        <p className="container_result_user col s2">№ OF USERS COMPLETING QUIZ</p>
        <p className="container_result_user col s2">№ IN-PERSON ATTENDEES</p>
      </div>
      {values.map(item => (
        <Item item={item} key={item.id} showUsersModal={showUsersModal}/>
      ))}
      <div>
        <Pagination
          {...paginationProps}
        />
      </div>
    </div>
  );
}

List.defaultProps = {};

List.propTypes = {};

export default List;



// WEBPACK FOOTER //
// ./src/components/Admin/Statistics/Webinars/List.jsx